import { ColorScale } from '.'

export const green: ColorScale = {
  c10: '#052D00',
  c20: '#0E4700',
  c30: '#166000',
  c40: '#217B00',
  c50: '#2E8E16',
  c60: '#40A42B',
  c70: '#54C241',
  c80: '#9DE695',
  c90: '#E1F6DF',
  c100: '#FFFFFF',
}
